// StickyTable
export const PAGE_PADDING = 40;
export const NAVIGATION_WIDTH = 250;
export const WIDE_NAVIGATION_WIDTH = 450;

export const MAX_WIDTH = 1240;

export const getHintWidth = (contentLength: number) => (contentLength > 70 ? 400 : 200);
